import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';

class PropertyTablePicker extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    handleChange(e) {

        e.preventDefault();

        let value = e.target.value;
        const name = e.target.name;

        // It is 1-based
        const index = parseInt(name.replace("clm.l", '').replace("clm.t", ''));
        const type = name.replace(index, '');

        // if I am deleting
        if (value === null || value === '') {

            if (index === 1) {
                return;
            }

            // Maybe we have to move
            for (let i = index; i < 8; i++) {
                this.props.handleChange(`clm.l${(i)}`, this.props.properties[`clm.l${i + 1}`].value);
                this.props.handleChange(`clm.t${(i)}`, this.props.properties[`clm.t${i + 1}`].value);
            }

            //this.props.handleChange(`clm.l${(8)}`, this.props.properties[`clm.l${8}`].valueMeta.off);
            //this.props.handleChange(`clm.t${(8)}`, this.props.properties[`clm.t${8}`].valueMeta.off);

            this.props.handleChange(`clm.l${(8)}`, 'Off');
            this.props.handleChange(`clm.t${(8)}`, 'Off');

            // while (this.props.properties[`clm.l${indexToCheck}`] !== undefined
            //     && this.props.properties[`clm.l${indexToCheck}`] !== null) {

            //     this.props.handleChange(`clm.l${(indexToCheck - 1)}`, this.props.properties[`clm.l${indexToCheck}`].value);
            //     this.props.handleChange(`clm.t${(indexToCheck - 1)}`, this.props.properties[`clm.t${indexToCheck}`].value);

            //     indexToCheck++;
            // }

            return;
        }

        //If I am adding
        if (type === 'clm.l' && !this.isOn(this.props.properties[`clm.t${index}`])) {
            // Setting the default clm.t
            this.props.handleChange(`clm.t${index}`, "" + (parseInt(this.props.properties[`clm.t${index - 1}`].value) + 1));
        } else if (type === 'clm.t' && !this.isOn(this.props.properties[`clm.l${index}`])) {
            // Setting the default clm.l
            this.props.handleChange(`clm.l${index}`, this.props.properties[`clm.l${index - 1}`].value);
        }

        if (type === 'clm.t') {
            let prevValue = this.props.properties[`${type}${index - 1}`].value;
            if (value === prevValue) {
                value = '' + (parseInt(value) + 1);
            }
        }

        this.props.handleChange(name, value);

        // const empties = [];
        // for (let i = 1; i < index; i++) {
        //     if (!this.isOn(this.props.properties[`clm.l${i}`]) || !this.isOn(this.props.properties[`clm.t${i}`])) {
        //         empties.push(i);
        //     }
        // }

        // if (empties.length === 0) {

        //     if (type === 'clm.l' && !this.isOn(this.props.properties[`clm.t${index}`])) {
        //         this.props.handleChange(`clm.t${index}`, this.props.properties[`clm.t${index - 1}`].value);
        //     } else if (type === 'clm.t' && !this.isOn(this.props.properties[`clm.l${index}`])) {
        //         this.props.handleChange(`clm.l${index}`, this.props.properties[`clm.l${index - 1}`].value);
        //     }
        //     this.props.handleChange(name, value);

        // } else {

        //     const firstIndex = empties[0];

        //     if (type === 'clm.l') {
        //         this.props.handleChange(`clm.t${firstIndex}`, this.props.properties[`clm.t${firstIndex - 1}`].value);
        //     } else if (type === 'clm.t') {
        //         this.props.handleChange(`clm.l${firstIndex}`, this.props.properties[`clm.l${firstIndex - 1}`].value);
        //     }
        //     this.props.handleChange(`clm.t${firstIndex}`, value);

        //     this.props.handleChange(`clm.l${index}`, this.props.properties[`clm.l${index}`].valueMeta.off);
        //     this.props.handleChange(`clm.t${index}`, this.props.properties[`clm.t${index}`].valueMeta.off);
        // }
    }

    renderPropertiesRow(type) {

        return Object.keys(this.props.properties).sort().map((key) => {

            if (this.props.properties[key].info.name.includes(type)) {

                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                // It is 1-based
                const index = parseInt(key.replace("clm.l", '').replace("clm.t", ''));
                const type = key.replace(index, '');

                // Only for Custom
                if (this.props.properties[key].info.name === "clm.t1") {
                    return (
                        <Col sm={this.props.sizePickers} style={{ padding: '0' }} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="number"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={0}
                                onChange={this.handleChange} />
                        </Col>
                    );
                }

                return (
                    <Col sm={this.props.sizePickers} style={{ padding: '0' }} key={this.props.properties[key].id}>
                        <input
                            id={key}
                            disabled={this.props.disabled || (index > 1 && (this.props.properties[`${type}${index - 1}`].value === 'Off' || this.props.properties[`${type}${index - 1}`].value === this.props.properties[`${type}${index - 1}`].valueMeta.off))}
                            className={className}
                            name={this.props.properties[key].info.name}
                            type="number"
                            min={this.props.properties[key].valueMeta.min}
                            max={this.props.properties[key].valueMeta.max}
                            value={this.getValue(this.props.properties[key])}
                            onChange={this.handleChange} />
                        {getIssuesComponent(errors, warnings)}
                    </Col>
                );

            }
            return null;
        });
    }

    getValue(property) {

        // Only for Custom
        if (property.info.name === "clm.l1") {
            if (property.value === "Off") {
                return "70";
            }
            return property.value;
        }

        if (property.value !== property.valueMeta.off) {
            return property.value;
        } else if (property.value === "Off") {
            return "";
        }
        return "";
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.firstRow.title}
                    </Col>
                    {this.renderPropertiesRow(this.props.firstRow.property)}
                    <Col sm={1} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.firstRow.measureUnit}
                    </Col>
                </Row>
                <Row>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.secondRow.title}
                    </Col>
                    {this.renderPropertiesRow(this.props.secondRow.property)}
                    <Col sm={this.props.sizeMeasureUnit} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.secondRow.measureUnit}
                    </Col>
                </Row>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyTablePicker);
